<h2>DE CIFRIS AGORA</h2>
<p>
    Partendo dal concetto greco di ἀγορά (assemblea, raduno), la mailing list <b>De Cifris Agora</b>
    permette ai soci di proporre i propri seminari a tutta la comunità De Cifris con lo scopo di
    aiutare a diffondere la crittografia e valorizzare le iniziative divulgative.
</p>

<p style="text-align: center;">
    <img src="../../../../assets/images/logos/logo agora transparent.png"
        style="width: 40%; min-width: 200px; margin: 20px auto 20px auto;">
</p>
<h3>Ricevere notizie</h3>
<p>
    Per iscrivervi alla mailing list e ricevere gli aggiornamenti,
    scrivete ad <a href="mailto:agora@decifris.it">agora&#64;decifris.it</a>. L'accesso è libero per
    i soci De Cifris.
</p>

<h3>Proporre un seminario</h3>
<p>
    Il proponente deve verificare che il seminario soddisfi i requisiti, prima di inviare una mail a
    <a href="mailto:agora@decifris.it">agora&#64;decifris.it</a> specificando:
</p>
<ul>
    <li>Titolo e data del seminario</li>
    <li>Nome ed affiliazione degli speaker</li>
    <li>Luogo e modalità (online, in presenza,...)</li>
</ul>
<h3>Requisiti per la sottomissione</h3>
<p> Ci aspettiamo che i seminari soddisfino questi requisiti:</p>
<ol>
    <li>
        il seminario deve essere gratuito ed aperto a tutti
    </li>
    <li>
        il proponente deve essere un socio De Cifris (<b>non è necessario per gli speaker</b>)
    </li>
    <li>
        il seminario deve essere organizzato da un ente di ricerca
    </li>
</ol>
<p>
    La De Cifris valuta solo l'attinenza del seminario e non la sua qualità, che è garantita
    dall'ente organizzatore.
</p>

<h3>PROSSIMI SEMINARI</h3>
<ul>

</ul>

<h3>SEMINARI PASSATI</h3>
<ul>
    <!--
                    TENGO QUESTO COME ESEMPIO DI ITEM PER I POSTERI
                    - L
                <li>
                    <b> 19 Gennaio 2022 -- 15:00 </b>
                    <ul>
                        <li>
                            <b>Fadi Barbara</b> -- Università di Torino <br>
                            <i>"Digital signature for interoperability and privacy in
                                blockchains"</i><br>
                            <a href=".././../../assets/attivita/gruppi/cifrisChain/
								FadiBarbara.pdf">Locandina</a> --
                            <a href="../../../assets/attivita/gruppi/cifrisChain/Allegato1_
								CifrisChain_SLIDE_Barbara.pdf">Slide</a> --
                            <a href="https://www.youtube.com/watch?v=6RU7xDmz7Ok">Video</a>
                            <br>
                        </li>
                    </ul>
                </li>
                -->
</ul>